import { EVENT_KEYS } from 'presentation/events';
import { gotoElement, flashElement } from 'presentation/utils';

export const mediateRequestUpdateEntriesLayout = (requestUpdateEntriesLayoutSignal, dispatch) => {
    return ((signal) => {
        const handleSignal = (payload) => {
            dispatch({
                type : EVENT_KEYS.UPDATE_ENTRIES_LAYOUT,
                payload
                
            })
        };
        
        signal.add(handleSignal);

        return {
            destroy() {
                signal.remove(handleSignal);
            }
        };
    })(requestUpdateEntriesLayoutSignal);
};

export const mediateRequestUpdateUpliftsLayout = (requestUpdateUpliftLayoutSignal, dispatch) => {
    return ((signal) => {
        const handleSignal = (payload) => {
            dispatch({
                type : EVENT_KEYS.UPDATE_UPLIFTS_LAYOUT,
                payload : {
                    currentNav : payload
                }
            })
        };
        
        signal.add(handleSignal);

        return {
            destroy() {
                signal.remove(handleSignal);
            }
        };
    })(requestUpdateUpliftLayoutSignal);
};

export const mediateRequestGotoTaskListItem = (gotoTaskListItemSignal) => {
    return ((signal) => {
        const handleSignal = (payload) => {
            gotoElement(`#${CSS.escape(payload)}`);
            flashElement(`#${CSS.escape(payload)} .MuiPaper-root`);
        };
        
        signal.add(handleSignal);

        return {
            destroy() {
                signal.remove(handleSignal);
            }
        };
    })(gotoTaskListItemSignal);
};

export const mediateRequestTaskListPosition = (taskListPosSignal, dispatch) => {
    return ((signal) => {
        const handleSignal = (payload) => {
            dispatch({
                type : EVENT_KEYS.RESET_TASK_LIST,
                payload
            });
        };
        
        signal.add(handleSignal);

        return {
            destroy() {
                signal.remove(handleSignal);
            }
        };
    })(taskListPosSignal);
};

export const mediateRequestUpdateEntryDialogsLayout = (updateEntryDialogLayoutSignal, dispatch) => {
    return ((signal) => {
        const handleSignal = (payload) => {
            dispatch({
                type : payload.dialogEvent,
                payload : payload.show
            });
        };
        
        signal.add(handleSignal);

        return {
            destroy() {
                signal.remove(handleSignal);
            }
        };
    })(updateEntryDialogLayoutSignal);
};

export const mediateRequestUpdateSearchLayout = (requestUpdateSearchLayoutSigna, dispatch) => {
    return ((signal) => {
        const handleSignal = (payload) => {
            dispatch({
                type : EVENT_KEYS.UPDATE_SEARCH_LAYOUT,
                payload : {
                    ...payload
                }
            });
        }
        
        signal.add(handleSignal);

        return  {
            destroy() {
                signal.remove(handleSignal);
            }
        };
    })(requestUpdateSearchLayoutSigna);
};
